export default "__VITE_ASSET__2pJIWBI4__"